import { useTranslation } from 'react-i18next';

const Partnership = () => {
  const { t } = useTranslation();

  const partners = [
    { name: t('partner_3'), desc: 'Japanese Business Partner', url: t('partner_3_url') },
    { name: t('partner_2'), desc: 'Japanese Business Partner', url: t('partner_2_url') },
    { name: t('partner_1'), desc: 'Japanese Business Partner', url: t('partner_1_url') },
  ];

  return (
    <section className="bg-navy-50 py-20 md:py-28" aria-labelledby="partnership-heading">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-center">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-gold-400" aria-hidden="true"></span>
              <p className="text-gold-500 text-xs md:text-sm font-semibold tracking-[0.25em] uppercase">
                {t('partner_label')}
              </p>
            </div>
            <h2 id="partnership-heading" className="text-2xl md:text-4xl lg:text-[2.75rem] font-bold text-navy-900 leading-tight mb-4">
              {t('partner_title')}
            </h2>
            <p className="text-lg md:text-xl text-gold-600 font-medium mb-6">
              {t('partner_subtitle')}
            </p>
            <p className="text-sm md:text-base text-gray-600 leading-[1.8]">
              {t('partner_desc')}
            </p>
          </div>

          <div className="lg:col-span-7 space-y-4" itemScope itemType="https://schema.org/ItemList">
            {partners.map((partner, index) => (
              <meta key={`meta-${index}`} itemProp="itemListElement" content={partner.name} />,
              partner.url ? (
                <a
                  key={partner.name}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="bg-white rounded-sm p-6 md:p-7 border-l-4 border-gold-400 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 block cursor-pointer group"
                  itemScope
                  itemType="https://schema.org/Organization"
                  itemProp="itemListElement"
                >
                  <div className="flex items-center gap-5">
                    <div className="flex items-center justify-center w-14 h-14 rounded-full bg-navy-50 flex-shrink-0">
                      <i className="ri-building-line text-2xl text-gold-500"></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <h3 itemProp="name" className="text-base md:text-lg font-semibold text-navy-900 group-hover:text-navy-700 transition-colors">
                          {partner.name}
                        </h3>
                        <i className="ri-external-link-line text-sm text-gray-400 group-hover:text-gold-500 transition-colors flex-shrink-0"></i>
                      </div>
                      <p itemProp="description" className="text-xs md:text-sm text-gray-500">{partner.desc}</p>
                    </div>
                  </div>
                </a>
              ) : (
                <div
                  key={partner.name}
                  className="bg-white rounded-sm p-6 md:p-7 border-l-4 border-gray-200"
                  itemScope
                  itemType="https://schema.org/Organization"
                  itemProp="itemListElement"
                >
                  <div className="flex items-center gap-5">
                    <div className="flex items-center justify-center w-14 h-14 rounded-full bg-navy-50 flex-shrink-0">
                      <i className="ri-building-line text-2xl text-gold-500"></i>
                    </div>
                    <div>
                      <h3 itemProp="name" className="text-base md:text-lg font-semibold text-navy-900">
                        {partner.name}
                      </h3>
                      <p itemProp="description" className="text-xs md:text-sm text-gray-500">{partner.desc}</p>
                    </div>
                  </div>
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partnership;
